import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [darkMode, setDarkMode] = useState(() => {
        const saved = localStorage.getItem('darkMode');
        return saved ? JSON.parse(saved) : false;
    });

    const [themeMode, setThemeMode] = useState(() => {
        const saved = localStorage.getItem('themeMode');
        return saved || 'classic';
    });

    // Dark Mode Persistence
    useEffect(() => {
        localStorage.setItem('darkMode', JSON.stringify(darkMode));
        if (darkMode) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [darkMode]);

    // Theme Mode Reflection (Persistence is handled manually on toggle)
    useEffect(() => {
        document.documentElement.classList.remove('theme-classic', 'theme-premium', 'theme-luxury');
        document.documentElement.classList.add(`theme-${themeMode}`);
    }, [themeMode]);

    const toggleDarkMode = () => setDarkMode(!darkMode);

    const toggleTheme = () => {
        setThemeMode(prev => {
            const next = prev === 'classic' ? 'premium' : prev === 'premium' ? 'luxury' : 'classic';
            localStorage.setItem('themeMode', next);
            return next;
        });
    };

    return (
        <ThemeContext.Provider value={{ darkMode, toggleDarkMode, themeMode, setThemeMode, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
